import GenericLazyLoadImage from 'components/generic/GenericLazyLoadImage'
import { Box } from 'components/generic/HomePageComponents'
import TopCities from 'components/TopCities'
import {
  MainDiv,
  CenteredRowDiv,
  ImageColumn,
  LinkColumn,
  SmallHeader,
  SmallLink,
  SmallText,
} from './Styled'
import { data } from 'lib/footer.js'
import get from 'lodash/get'

import CareguideFamily from './CareguideFamily'

export const Footer = ({ domain, site }) => {
  const { header, mainItems, secondaryItems } = data.footer
  const siteName = get(site, 'name')
  const footerData = get(site, 'navigation.footer.navigation_items')
  const topCitiesData = get(site, 'assets.topCitiesData')
  return (
    <>
      <TopCities topCitiesData={topCitiesData} footerData={footerData} />
      <CareguideFamily
        domain={domain}
        header={header}
        colouredTextItems={mainItems}
        cities={secondaryItems}
        siteName={siteName}
      />
      <MainDiv>
        <CenteredRowDiv>
          <ImageColumn order={['6', '1', '1']} alignItems={['center', 'cemter', 'stretch']}>
            <GenericLazyLoadImage
              mb='20px'
              width={['190px', '190px', '140px']}
              mt={['40px', '40px', '0px']}
              src='https://cdn4.careguide.com/assets/branding/tash/logos/logo_careguide-tagline_RGB-c8f9c27c8adf4221e17375cab5e7506e81a053dd8c28b5c65ee6ba3cefa46678.svg'
            />
            <Box display='flex' flexDirection={['row', 'row', 'column']}>
              <SmallLink fontSize={['12px', '12px', '14px']} mr='8px' href='/privacy'>
                Privacy Policy
              </SmallLink>
              <SmallLink fontSize={['12px', '12px', '14px']} mr='8px' href='/terms-of-service'>
                Terms of Service
              </SmallLink>
              <SmallLink fontSize={['12px', '12px', '14px']} href='/cancellation-policy'>
                Cancellation Policy
              </SmallLink>
            </Box>
            <SmallText fontSize={['12px', '12px', '14px']} textAlign='center'>
              © 2019 CareGuide Inc.
            </SmallText>
          </ImageColumn>
          <LinkColumn order='2'>
            <SmallHeader mb={['5px', '5px', '35px']} mt={['40px', '40px', '0px']}>
              Contact
            </SmallHeader>
            <SmallText>1100-119 Spadina Ave</SmallText>
            <SmallText>Toronto, On</SmallText>
            <SmallText>M5V2L1</SmallText>
          </LinkColumn>
          <LinkColumn order='3'>
            <SmallHeader mb={['5px', '5px', '35px']} mt={['40px', '40px', '0px']}>
              Payroll Services
            </SmallHeader>
            <SmallLink href=''>Nanny Tax & Payroll Services</SmallLink>
          </LinkColumn>
          <LinkColumn order='4'>
            <SmallHeader mb={['5px', '5px', '35px']} mt={['40px', '40px', '0px']}>
              Need Help?
            </SmallHeader>
            <SmallLink href='https://help.careguide.com/hc/en-us'>Help Center</SmallLink>
            <SmallLink href='/security-info'>Security Info</SmallLink>
          </LinkColumn>
          <LinkColumn order='5'>
            <SmallHeader mb={['5px', '5px', '35px']} mt={['40px', '40px', '0px']}>
              Social
            </SmallHeader>
            <SmallLink href='https://twitter.com/careguide'>Twitter</SmallLink>
            <SmallLink href='https://facebook.com/careguide'>Facebook</SmallLink>
            <SmallLink href='https://www.linkedin.com/company/careguide/'>LinkedIn</SmallLink>
          </LinkColumn>
        </CenteredRowDiv>
      </MainDiv>
    </>
  )
}

export default Footer
